// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__2mYRp","logo":"navbar_logo__9U0Ob"};